import {useMutation} from "react-query";
import {Formik, Form} from "formik";
import {validator} from "@reside/forms";
import {
  PublicFormLayout,
  Button,
  TextField,
  Box,
  Text,
  FieldErrorText,
} from "@reside/ui";

import {AuthService} from "../../services/AuthService";
import {dispatch} from "../../store";
import {DocumentTitle} from "../../atoms/document-title";
import {StyledLink} from "../page-admin-login/style";

export const PageAdminSSOLoginForm = () => {
  const {
    mutate: samlMutate,
    error: samlError,
    isLoading: isSamlLoading,
  } = useMutation(
    async (email: string) => {
      const idpResponse = await AuthService.getIdpListByDomain(email);

      const {organizationId, idProvider} = idpResponse.data;

      return AuthService.getSamlRedirect(organizationId, idProvider);
    },
    {
      onMutate: () => {
        dispatch.adminSession.reset();
      },
      onSuccess: ({data}) => {
        if (data?.url) {
          window.location.href = data.url;
        }
      },
    },
  );

  return (
    <Formik
      initialValues={{email: ""}}
      onSubmit={values => {
        samlMutate(values.email);
      }}
      validate={values =>
        validator.validateAll(values, {
          email: "required|email",
        })
      }
    >
      {() => (
        // skipcq: JS-0415
        <>
          <DocumentTitle title="Reside - Admin - Sign In with SSO" />
          <PublicFormLayout title="Sign in with SSO">
            <Form>
              <TextField
                name="email"
                type="email"
                label="Email Address"
                testId="input-email-sso"
              />

              {samlError && (
                <FieldErrorText data-test-id="validator-error">
                  We couldn&apos;t sign you in with SSO.
                </FieldErrorText>
              )}

              <Button
                testId="ssoLoginButton"
                type="submit"
                color="primary"
                disabled={isSamlLoading}
                style={{width: "100%", marginTop: "32px"}}
              >
                {isSamlLoading ? "Processing..." : "Sign in with SSO"}
              </Button>

              {samlError && (
                <Box marginTop="32px">
                  <Text as="p" color="errorRed" lineHeight="1.2" fontSize={3}>
                    The email address you entered may not be registered for SSO,
                    or your organization may not have SSO enabled.
                  </Text>
                  <br />
                  <Text as="p" color="errorRed" lineHeight="1.2" fontSize={3}>
                    Please contact your administrator or try signing in with a
                    password.
                  </Text>
                </Box>
              )}

              <div style={{marginTop: "32px"}}>
                <StyledLink to="/admin">Sign in with password</StyledLink>
              </div>
            </Form>
          </PublicFormLayout>
        </>
      )}
    </Formik>
  );
};
